import { SkeletonBox } from "@/base-components/skeleton";
import { LoadingPage } from "@/components/loading-page";
import { useIsMobile } from "@/hooks/use-is-mobile";

import logo from "../assets/logo.svg";

// Shaped like `App`: the fixed `AppBar` and the page area under it.
export function LoadingHome() {
  const isMobile = useIsMobile();
  return (
    <div className="absolute inset-0 flex flex-col">
      <header className="flex h-[70px] flex-none items-center border-b border-border bg-background">
        <div className="flex flex-1 items-center">
          <div className="ml-3 h-[36px] w-[36px] flex-none rounded-full shadow lg:h-[44px] lg:w-[44px]">
            <img
              alt=""
              src={logo}
              className="h-[36px] w-[36px] lg:h-[44px] lg:w-[44px]"
            />
          </div>
        </div>
        {!isMobile && (
          <div className="flex items-center gap-1 lg:gap-1.5">
            <SkeletonBox className="h-10 w-10" />
            <SkeletonBox className="h-10 w-10" />
            <SkeletonBox className="h-10 w-10" />
          </div>
        )}
        <div className="w-1 lg:w-1.5" />
        <SkeletonBox className="h-10 w-10 rounded-full" />
        <div className="w-2.5" />
      </header>
      {/* The page area, with the same scrollbar room as #scroll-container. */}
      <div className="relative flex flex-1 flex-col overflow-y-auto [scrollbar-gutter:stable]">
        <LoadingPage />
      </div>
    </div>
  );
}
